import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { agendaLimpiarTurnoSeleccionado } from '../../../actions/turnos/agenda';
import { fetchConToken } from '../../../helpers/fetch';
import { onlyUnique } from '../../../helpers/onlyUnique';

export const ListaHorarios = ({virtual, presencial, itemsHoras, selectedDay, selectedTime, idEspecialidad, idCentroMedico, setSelectedTime}) => {
    const dispatch = useDispatch();
    const [sobreTurnos, setSobreTurnos] = React.useState(false);
    const [profesionalesSobreTurnos, setprofesionalesSobreTurnos] = React.useState([]);


    const handleClickTime = (item) => {
        setSelectedTime(item)
        dispatch( agendaLimpiarTurnoSeleccionado(item) )
    }

    useEffect(() => {
        const verificarSobreTurnos = async () => {
            const parametros = `idEspecialidad=${idEspecialidad}&idCentroMedico=${idCentroMedico}&presencial=${presencial}&videoConsulta=${virtual}&fecha=${selectedDay.toISOString()}`;
            const response = await fetchConToken(`Agenda/traerSobreTurnos?${parametros}`)
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const lista = await response.json();
                if(lista.length>0){
                    setSobreTurnos(true)
                    setprofesionalesSobreTurnos(lista.map(s => s.efectorRed.nombreEfector).filter(onlyUnique));
                }
            }
        };
        selectedDay&& verificarSobreTurnos();
    }, [selectedDay, idEspecialidad, idCentroMedico, presencial, virtual])

    return ( 
        <>
            {itemsHoras.map((item) => (
                <Button 
                    variant="contained"
                    color="primary"
                    style={{margin: 5}}
                    disabled={selectedTime === item ? true : false}
                    onClick={() => handleClickTime(item)}
                >
                    {item}
                </Button>
            ))}
            {sobreTurnos&&
                <h3>Hay sobreturnos disponibles para los sig. profesionales: {profesionalesSobreTurnos.join(' - ')}</h3>
            }
        </>
     );
}